"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withGA = exports.hasGA = exports.default = void 0;
var hasGA = function hasGA() {
  return typeof ga === 'function';
};
exports.hasGA = hasGA;
var withGA = function withGA(fn) {
  return function () {
    if (hasGA()) {
      fn.apply(void 0, arguments);
    }
  };
};
exports.withGA = withGA;
var _default = {
  hasGA: hasGA,
  withGA: withGA
};
exports.default = _default;
//# sourceMappingURL=googleAnalytics.js.map